import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { adminStaffListQueries } from '@/services/adminStaff/adminStaff.queries';
import { useSearch } from '@tanstack/react-router';

export const useAdminStaffList = () => {
  const search = useSearch({ from: '/(app)/users/admin/' });
  const { createdDate, page, fetch, q } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isFetched, isLoading } = useQuery({
    ...adminStaffListQueries.list({
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
      row: page,
      fetch: fetch,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    adminStaff: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
